/**
 * SIP Context
 * Provides the Context definition and Hook
 */

import { createContext, useContext } from "react";

// SIP State
export interface SipState {
  isConnected: boolean;
  isCallInProgress: boolean;
  isCallRinging: boolean;
  isMicrophoneGranted: boolean;
  isRegistered: boolean;
  error: string | null;
}

// SIP Actions
export interface SipActions {
  connect: () => void;
  disconnect: () => void;
  makeCall: (contactId: string) => void;
  endCall: () => void;
  sendDTMF: (digit: string) => void;
  requestMicrophoneAccess: () => Promise<boolean>;
  clearError: () => void;
}

export interface SipContextValue extends SipState, SipActions {}

export const SipContext = createContext<SipContextValue | null>(null);

/**
 * Hook to access the shared SIP instance
 */
export function useSipContext(): SipContextValue {
  const context = useContext(SipContext);
  if (!context) {
    throw new Error("useSipContext must be used within a SipProvider");
  }
  return context;
}
